export default function Header({children}){
    return <div className="header">{children}</div>
}